<template>
  <button @click="list" type="button" class="btn btn-sm btn-secondary mr-1">
    <font-awesome-icon icon="info"/>&nbsp;{{$t('info')}}
    <b-modal size="xl" :content-class="tabIndex !== 0 ? 'modal-content-2' : ''" header-class="pb-0" min header-bg-variant="white" v-model="showList" hide-footer ok-only no-close-on-backdrop no-enforce-focus>
      <template #modal-title>
        <b-tabs nav-class="nav-item-2" v-model="tabIndex">
          <b-tab>
            <template #title>
              <font-awesome-icon icon="cog"/>&nbsp;{{$t('setting')}}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              <font-awesome-icon icon="list"/>&nbsp;{{ $t('contactList') }}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              <font-awesome-icon icon="history"/>&nbsp;{{ $t('callHistory') }}
            </template>
          </b-tab>
        </b-tabs>
      </template>
      <template v-if="tabIndex === 0">
        <assign :campaign="campaign"></assign><hr>
        <contact-fields :campaign="campaign"></contact-fields><hr>
        <report-fields :campaign="campaign"></report-fields>
      </template>
      <contact-list v-if="tabIndex === 1" :campaign="campaign"></contact-list>
      <campaign-history v-if="tabIndex === 2" :campaign="campaign"></campaign-history>
    </b-modal>
  </button>
</template>
<script>
import Assign from './setting/Assign';
import ContactFields from './setting/ContactFields'
import ReportFields from './setting/ReportFields'
import ContactList from './ContactList';
import CampaignHistory from './CampaignHistory';

export default {
  props: {
    client: Object,
    campaign: Object
  },
  components: {Assign, ContactFields, ReportFields, ContactList, CampaignHistory},
  data() {
    return {
      showList: false,
      tabIndex: 0
    }
  },
  methods:{
    list() {
      this.showList = true;
    }
  },
  i18n: {
    messages: {
      en: {
        setting: "Setting",
        contactList: "Contact list",
        callHistory: "Call history",
        campaignContactFields: "Campaign contact fields",
        campaignReportFields: "campaign report fields",
      },
      vi: {
        setting: "Cài đặt",
        contactList: "Danh sách liên hệ",
        callHistory: "Lịch sử gọi",
        campaignContactFields: "Thông tin liên hệ",
        campaignReportFields: "Thông tin báo cáo",
      }
    }
  },
}
</script>
<style>
.modal-content-2 {
  background-color: #e5e5e5;
}
.nav-item-2 {
  font-weight: normal;
  font-size: medium;
}
</style>